// extracted by mini-css-extract-plugin
export default {"btn-password":"PasswordInputWithIcon_btn-password__6WlQH"};